import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "ep-theme";
export const applyTheme = (t) => document.documentElement.classList.toggle("light", t === "light");
export const initTheme = () => applyTheme(localStorage.getItem(KEY) || "dark");

export const useTheme = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || "dark");
  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(KEY, theme);
    window.dispatchEvent(new Event("ep-theme"));
  }, [theme]);
  return [theme, () => setTheme(theme === "light" ? "dark" : "light")];
};

export const ThemeToggle = () => {
  const [theme, toggle] = useTheme();
  const light = theme === "light";
  return (
    <button onClick={toggle} data-testid="theme-toggle-btn" title={light ? "Switch to dark mode" : "Switch to light mode"}
      className="rounded-sm p-2 text-slate-400 transition-colors hover:bg-slate-800 hover:text-white">
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span className="sr-only">{light ? "Dark mode" : "Light mode"}</span>
    </button>
  );
};
